<template>
  <div id="countDown" style="background-color:white;">
    <img :src="isamnet" style="width:100%" />

    <div v-if="!isTimeout" class="countdown-wrapper" :style="slideImageSize">
      <a
        :href="creative.landing_page"
        target="_blank"
        style="margin: 30px auto;"
      >
        <img
          class="countdown-container top"
          :src="creative.top_layer_image_url"
          :width="slideImageSize.width"
          :height="slideImageSize.height"
        />
        <div class="countdown-container" :style="slideImageSize">
          <div
            class="slide"
            v-for="(image, index) in creative.images"
            :key="index"
          >
            <img
              :src="image.image_url"
              alt="pure css slider"
              :width="slideImageSize.width"
              :height="slideImageSize.height"
            />
          </div>
        </div>
        <div class="countdown-timer" :style="timerPosition.absolute">
          <div :style="timerPosition.mr">
            {{ countDownTimerObj.days }}
          </div>
          <div :style="timerPosition.mr">
            {{ countDownTimerObj.hours }}
          </div>
          <div :style="timerPosition.mr">
            {{ countDownTimerObj.miniutes }}
          </div>
          <div>
            {{ countDownTimerObj.seconds }}
          </div>
        </div>
      </a>
    </div>

    <div v-else class="countdown-wrapper" :style="slideImageSize">
      <a
        :href="creative.ultimate_landing_page"
        target="_blank"
        style="margin: 30px auto;"
      >
        <img
          class="countdown-container top"
          :src="creative.ultimate_image_url"
          :width="slideImageSize.width"
          :height="slideImageSize.height"
        />
      </a>
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/banner/bg2.png"
      style="width:100%"
    />
  </div>
</template>
<script>
import mixPreview from "@/components/mixins/preview.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      countDownTimerObj: {
        days: "",
        hours: "",
        miniutes: "",
        seconds: "",
      },
      endTimeStamp: Date.parse(this.creative.date_time),
      isTimeout: false,
      slideImageSize: {
        width: this.creative.width + "px",
        height: this.creative.height + "px",
      }
    };
  },
  created() {
    let currentTimeStamp = Date.now();
    if (this.endTimeStamp - currentTimeStamp < 0) {
      this.isTimeout = true;
    }
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if (domain === "prism.amnet.tw") {
        isAmnet += "/amnet/bg2.png";
      } else {
        isAmnet += "/banner/bg1.png";
      }
      return isAmnet;
    },
    timerPosition() {
      if (
        this.creative.width === 300 &&
        this.creative.height === 250
      ) {
        return {
          mr: { marginRight: "18px" },
          absolute: {
            right: "13px",
            bottom: "17px",
          },
        };
      } else if (
        this.creative.width === 320 &&
        this.creative.height === 480
      ) {
        return {
          mr: { marginRight: "24px" },
          absolute: {
            right: "15px",
            bottom: "22px",
          },
        };
      }
    },
  },
  mixins: [mixPreview, mixMobile],
  mounted() {
    this.viewport();
    this.timer = setInterval(() => {
      this.setCountDownTimerObj();
    }, 1000);
  },
  methods: {
    setCountDownTimerObj() {
      const currentTimeStamp = Date.now();
      let countDownTime =
        this.endTimeStamp - currentTimeStamp > 0
          ? (this.endTimeStamp - currentTimeStamp) / 1000
          : 0;
      let date = Math.floor(countDownTime / 86400);
      let hour = Math.floor((countDownTime % 86400) / 3600);
      let miniute = Math.floor((countDownTime % 3600) / 60);
      let second = Math.floor(countDownTime % 60);
      this.countDownTimerObj.days = date > 9 ? date : "0" + date;
      this.countDownTimerObj.hours = hour > 9 ? hour : "0" + hour;
      this.countDownTimerObj.miniutes = miniute > 9 ? miniute : "0" + miniute;
      this.countDownTimerObj.seconds = second > 9 ? second : "0" + second;
      if (countDownTime <= 0) {
        this.isTimeout = true;
        clearInterval(this.timer);
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.mr-18
  margin-right: 18px
.countdown-wrapper
  margin: 30px auto
  position: relative
  overflow: hidden
.countdown-timer
  z-index: 199
  position: absolute
  display: flex
  color: white
.countdown-container
  position: absolute
  top: 0px
  left: 0px
  &.top
    z-index:99
    display: block
  .slide
    position: absolute
    top: 0px
    left: 0px
    opacity: 1
    filter: alpha(opacity=100)
    left: 100%
    width: 100%
    -webkit-animation: round 12s linear infinite
    animation: round 12s linear infinite
    &:nth-child(1)
      -webkit-animation-delay: 0s
      animation-delay: 0s
    &:nth-child(2)
      -webkit-animation-delay: 4s
      animation-delay: 4s
    &:nth-child(3)
      -webkit-animation-delay: 8s
      animation-delay: 8s

@-webkit-keyframes round
  8.3%
    opacity: 1
    filter: alpha(opacity=100)
    left: 0
    /* 0-1秒滑入*/
  33.3%
    opacity: 1
    filter: alpha(opacity=100)
    left: 0
    /* 1-4秒靜止*/
  41.5%
    opacity: 1
    filter: alpha(opacity=100)
    left: -100%
    /* 4-5秒滑出*/
  42%
    opacity: 0
    filter: alpha(opacity=0)
    left: -100%
    /* 5秒變透明*/
  43%
    opacity: 0
    filter: alpha(opacity=0)
    left: 100%
    /* 5秒回到原位*/
</style>
